import React, { useState } from "react";
import LayoutDashboard from "../layout/LayoutDashboard";
import TableProduct from '../components/Merchandise/TableProduct'
import MenuProduct from "../components/Merchandise/MenuProduct";
import SearchProductMerchan from "../components/Merchandise/SearchProductMerchan";

const BtnAddProduct = (props) => {
  return (
    <>
      <button className="bg-orange-500 text-white font-bold py-2 px-4 rounded ml-auto" onClick={props.haddleChange}>+ Tambah produk</button>
    </>
  )
}
const BtnBack = (props) => {
  return (
    <>
    <p>Pilih produk dari daftar berikut untuk dijual</p>
      <button className="bg-green-100 text-white font-bold py-2 px-4 rounded ml-auto" onClick={props.haddleChange}>Kembali</button>
    </>
  )
}



const Merchandise = () => {
  const [addProduct, setAddProduct] = useState(false);

  function ChangeAddProduct() {
    setAddProduct(!addProduct);
  }

  return (
    <>
      <LayoutDashboard>
        <section className="ml-4 w-full">
          <div className="md-flex">
            <div className="bg-white">
              <div class="mb-4">
                <div className="flex  w-full py-4 overflow-hidden bg-white shadow-lg px-6">
                  {addProduct ? null : <SearchProductMerchan />}
                  {addProduct ? <BtnBack haddleChange={() => { ChangeAddProduct() }} /> : <BtnAddProduct haddleChange={() => { ChangeAddProduct() }} />}
                </div>
              </div>
            </div>
          </div>
          {addProduct ? <MenuProduct />  : <TableProduct/> }

        </section>
      </LayoutDashboard>
    </>
  );
};

export default Merchandise;
